import { mountDrugDetailApp } from '../../tags/shared/mount_drug_modal';

mountDrugDetailApp('dtc-drug-detail-app');
